<mat-expansion-panel>
  <mat-expansion-panel-header>
    <mat-panel-title> Other Details </mat-panel-title>
    <mat-panel-description>
      <!-- <img [src]="personal" /> -->
    </mat-panel-description>
  </mat-expansion-panel-header>
  <div class="spinner" *ngIf="miscelleneous === undefined">
    <mat-spinner mode="indeterminate"></mat-spinner>
  </div>
  <div class="expansion-content" *ngIf="miscelleneous !== undefined">
    <div class="cell">
      <label>Health Goal : </label>
      <span>{{ miscelleneous.healthGowl }}</span>
    </div>
    <div class="cell">
      <label>Social : </label>
      <span>{{ miscelleneous.modeOfCommunication }}</span>
    </div>
    <div class="cell">
      <label>Anything Else : </label>
      <span>{{ miscelleneous.writeAnything }}</span>
    </div>
  </div>
</mat-expansion-panel>
